/**
 * Exports never carry the value of a variable marked secret (review F2,
 * 28.09.2026) — for COLLECTION variables (`settings.collection_variables`) and
 * FOLDER variables (`settings.folders[].variables`) alike, in every format.
 * The row itself stays (name, enabled, `secret: true`) so the importer knows
 * there is a value to supply; only `value` is blanked.
 */
export function blankSecretValues(rows) {
  if (!Array.isArray(rows)) return rows;
  return rows.map((r) => (r && typeof r === 'object' && r.secret ? { ...r, value: '' } : r));
}

/** A copy of `settings` with every secret collection/folder variable value blanked. */
export function redactSettingsSecrets(settings) {
  if (!settings || typeof settings !== 'object') return settings;
  const next = { ...settings };
  if (Array.isArray(next.collection_variables)) {
    next.collection_variables = blankSecretValues(next.collection_variables);
  }
  if (Array.isArray(next.folders)) {
    next.folders = next.folders.map((f) =>
      f && Array.isArray(f.variables) ? { ...f, variables: blankSecretValues(f.variables) } : f
    );
  }
  return next;
}
